import { openMobileWallet as s, toDeepLink as p } from "@roninnetwork/wallet-sdk";
import { WalletExtensionRdns as f } from "../../temp-lib/constants/web3.js";
import d from "../../temp-lib/hooks/web3/useWeb3.js";
import { useState as m, useEffect as u } from "react";
const L = () => {
  const {
    connectors: o
  } = d(), [n, r] = m(), e = o.find((t) => t.id === f.WalletConnect);
  return u(() => {
    if (!e)
      return;
    const t = (i) => {
      i.type === "display_uri" && r(i.data);
    };
    return e == null || e.emitter.on("message", t), () => {
      e == null || e.emitter.off("message", t);
    };
  }, [e]), {
    roninQRCode: n,
    openRoninMobileWallet: s,
    getDeepLink: () => n ? p(n) : ""
  };
};
export {
  L as default
};
//# sourceMappingURL=useWalletConnect.js.map
